import useUserAccount from "src/store/userAccountState";
import { anyPass, equals } from "ramda";
import type { Pred } from "ramda";
import chainGet from "src/services/network/chainGet";
import permissions from "src/constants/permissions";

type PermissionKeysType = keyof typeof permissions;
type PerimssionValsType = typeof permissions[PermissionKeysType];

const useIsCurrentUserAdminOrFull = () => {
  const { userAccount } = useUserAccount();

  const permission = chainGet(userAccount?.permission, "Limited");

  const permissionLowerCase =
    permission.toLowerCase() as typeof permissions[PermissionKeysType];

  const isCurrentUserAdminOrFull = anyPass<Pred<PerimssionValsType[]>>([
    equals<PerimssionValsType>(permissions.SUPERADMIN),
    equals<PerimssionValsType>(permissions.ACCOUNTADMIN),
    equals<PerimssionValsType>(permissions.FULL),
  ])(permissionLowerCase);

  return isCurrentUserAdminOrFull;
};

export default useIsCurrentUserAdminOrFull;
